/** Public homepage hero banner (DigitalOcean Spaces). */
export const HOME_HERO_BANNER_IMAGE_URL =
  "https://bizcover-media-uploads.nyc3.digitaloceanspaces.com/homepage/banners/bizcoverindia-main-hero-v1.png";
